module.exports = __webpack_public_path__ + "img/chiesi-logo.e036156a.png";